module.exports = __webpack_public_path__ + "static/rend2-90d61b42a48116e18e310165f3d87e9d.png";